import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ROUTES } from "./RouteConstants";

import Home from "../pages/home/Home.jsx";
import Navbar from "../components/navbar/Navbar.jsx";
import Footer from "../components/footer/Footer.jsx";
import Contact from "../pages/contact/Contact.jsx";
import ConsumerHome from "../pages/consumerHome/ConsumerHome.jsx";
import { UserProvider } from "../UserContext"; // Import the UserProvider
import ConsumerContact from "../pages/consumerContact/ConsumerContact.jsx";

const ReactRoute = () => {
    return (
        <UserProvider>
            <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route path={ROUTES.home} element={<Home />} />
                    <Route path={ROUTES.customerHome} element={<ConsumerHome />} />
                    <Route path={ROUTES.djContact} element={<Contact />} />
                    <Route path={ROUTES.customerContact} element={<ConsumerContact />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </UserProvider>
    );
};

export default ReactRoute;
